import { FC } from 'react';
import { CatSkeleton } from '@blocks-react/components/Skeleton';
import style from '../NotificationDrawer.module.scss';

export const NotificationSkeletonLoader: FC = () => {
  const loaderArray: Array<undefined> = [...Array(25)];
  const loaderCount = 0;
  return (
    <div
      className={`${style['skeleton-loader']} mt-4`}
      data-testid="skeleton-loader"
    >
      {loaderArray?.map((_value, index) => {
        return (
          <div
            key={`${loaderCount + index}`}
            data-testid="notification-skeleton"
          >
            <CatSkeleton
              className="cat-u-display-block cat-u-margin-bottom-sm"
              size="sm"
              width="40%"
            />
            <CatSkeleton
              className="cat-u-display-block cat-u-margin-bottom-sm"
              size="sm"
              width="40%"
            />
            <CatSkeleton
              className="cat-u-display-block cat-u-margin-bottom-sm"
              size="sm"
              slot="footer"
            />
          </div>
        );
      })}
    </div>
  );
};
